const PEN = new Intl.NumberFormat("es-PE", {
	style: "currency",
	currency: "PEN",
	useGrouping: false,
});
export const currencyFormat = (amount: number) => PEN.format(amount);
